import { Component, Input, Output, EventEmitter } from '@angular/core';

import * as Objects from '@core/objects';
import { ProjectLogbookEventList } from '@app/models/logbook-events.model';


@Component({
    selector: 'project-details-logbook-event-header',
    templateUrl: './event-header.component.html',
    styleUrls: ['./event-header.component.scss']
})
export class ProjectDetailsLogbookEventHeaderComponent {
	@Input() event: Objects.LogbookEvent;
    @Output() open = new EventEmitter();
    @Output() selectGroup = new EventEmitter<string>();

    public opened: boolean = false;
    public titlesList: Objects.EventTrack[] = ProjectLogbookEventList;

    public toogleDetails() {
        this.opened = !this.opened;
        
        this.open.emit();
    }

    getTitle(event: Objects.LogbookEvent){
        let text = this.titlesList.filter((e: Objects.EventTrack)=> e.id == event.type);
        return text.length > 0 ? text[0].title : 'Not defined yet ==> '+event.type;
    }

    displayGroup(group: string) : void {
        this.selectGroup.emit(group);
    }

}